import { Spinner } from '@mi-front/ui';
import { Alert, AlertTitle, Box } from '@mui/material';
import moment from 'moment-timezone';
import { FormattedMessage } from 'react-intl';
import { Fragment } from '../../../../../../types';
import { ExternalExportStart } from './ExternalExportStart';

interface Props {
  fragment: Fragment;
}

export function ExternalExportStatusInfo(p: Props) {
  const { externalExport } = p.fragment;

  if (!externalExport || externalExport.status === 'NONE') {
    return (
      <Alert
        severity="warning"
        sx={{
          '.MuiAlert-message': {
            overflow: 'visible',
          },
        }}
      >
        <AlertTitle>
          <FormattedMessage
            id="fragments.exportStatus.none"
            defaultMessage="Fragmento no exportado aún"
          />
        </AlertTitle>
        {p.fragment.media.status === 'READY' && (
          <Box mt={2}>
            <ExternalExportStart fragmentId={p.fragment.id} fragment={p.fragment} />
          </Box>
        )}
      </Alert>
    );
  }

  return (
    <div>
      {externalExport.status === 'WAITING_FOR_MEDIA' && (
        <Alert severity="info">
          <AlertTitle>
            <FormattedMessage
              id="fragments.exportStatus.waiting"
              defaultMessage="Esperando por media para iniciar exportación"
            />
          </AlertTitle>
        </Alert>
      )}
      {externalExport.status === 'IN_PROGRESS' && (
        <Alert severity="info">
          <AlertTitle>
            <FormattedMessage
              id="fragments.exportStatus.process"
              defaultMessage="Exportando fragmento..."
            />
          </AlertTitle>
          <div>
            <Spinner />
          </div>
        </Alert>
      )}
      {externalExport.status === 'ERROR' && (
        <Alert severity="error">
          <AlertTitle>
            <FormattedMessage
              id="fragments.exportStatus.error"
              defaultMessage="Ocurrió un error durante el export"
            />
          </AlertTitle>
        </Alert>
      )}
      {externalExport.status === 'READY' && (
        <Alert severity="success">
          <AlertTitle>
            <FormattedMessage id="fragments.exportStatus.ready" defaultMessage="Listo" />
          </AlertTitle>
          <div>
            <FormattedMessage
              id="fragments.exportStatus.readyMsg"
              defaultMessage="Exportación lista"
              values={{
                date: moment(externalExport.completedAt).format('DD/MM HH:mm'),
                file: externalExport.filename,
              }}
            />
          </div>
        </Alert>
      )}
    </div>
  );
}
